import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import React from 'react';

import { DataLayerProvider } from '@shared/v2/contexts/DataLayerContext';

import { HomePageProvider } from '@/components/HomePage/hooks/useHomePage';
import { Meta } from '@/v2/components/global/Meta';
import { HomeView } from '@/v2/components/pages/HomeView';
import { getHomePage } from '@/v2/services/bff/getHomePage';

export const getStaticProps = async ({ preview }: GetStaticPropsContext) => {
  const props = await getHomePage({
    preview,
  });

  return {
    props,
    revalidate: 300,
  };
};

const dataLayerData = { pageName: 'Home page' };

const HomePage = ({
  homePage,
  meta,
  ...rest
}: InferGetStaticPropsType<typeof getStaticProps>) => (
  <DataLayerProvider value={dataLayerData}>
    <HomePageProvider value={homePage}>
      <Meta {...meta} />
      <HomeView homePage={homePage} {...rest} />
    </HomePageProvider>
  </DataLayerProvider>
);

export default HomePage;
